import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  set<T>(key: string, value: T) {
    const data = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, data);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T = any>(key: string) {
    const data = localStorage.getItem(key);
    if (!data)
      return null;

    try {
      return JSON.parse(data) as T;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    catch (e) {
      return data as T;
    }
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
